import axios from 'axios';

const API_PREFIX = '/marketplace';

export function traditionalSignup(options = {}) {
  const headers = {};
  const { cookie } = options;
  const path = `${API_PREFIX}/traditional-signup`;

  if (cookie) {
    headers.cookie = cookie;
  }

  return axios.post(path, options, { headers });
}

export function traditionalLogin(options = {}) {
  const headers = {};
  const { cookie } = options;
  const path = `${API_PREFIX}/traditional-login`;

  if (cookie) {
    headers.cookie = cookie;
  }

  return axios.post(path, options, { headers });
}

export function traditionalForgotPassword(options = {}) {
  const headers = {};
  const { cookie } = options;
  const path = `${API_PREFIX}/forgotten-password`;

  if (cookie) {
    headers.cookie = cookie;
  }

  return axios.post(path, options, { headers });
}

export function resendActivationUser(id) {
  const path = `${API_PREFIX}/resend-activation`;

  return axios.post(path, { id });
}

export function setNewPassword(id, password) {
  const path = `${API_PREFIX}/set-new-password`;

  return axios.post(path, { id, password });
}

export function emailSignupWithoutPassword(options = {}) {
  const path = `${API_PREFIX}/email-signup`;
  const headers = {};
  const { cookie } = options;

  if (cookie) {
    headers.cookie = cookie;
  }

  return axios.post(path, options, { headers });
}

export default {
  traditionalSignup,
  traditionalLogin,
  traditionalForgotPassword,
  resendActivationUser,
  setNewPassword,
  emailSignupWithoutPassword
};
